// extracted by mini-css-extract-plugin
export default {"isFaded":"NetworkGuardWrap_isFaded__NuDW-","cta":"NetworkGuardWrap_cta__CZt+C"};